module.exports = __webpack_public_path__ + "static/media/LN.50755211.png";